import { createContext, useContext } from "react";

import { ViewportContextType } from "./types";

export const ViewportContext = createContext<ViewportContextType>(
  undefined as unknown as ViewportContextType
);

const useInViewport = (): ViewportContextType => {
  const context = useContext(ViewportContext);
  if (typeof context === "undefined") {
    return { visible: true, hasProvider: false };
  }
  return context;
};

export default useInViewport;
